import { render } from "./DefaultLayout.vue?vue&type=template&id=6e4ab15e"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/krisflajs/Projects/DDStudios/DDS-platform/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__